import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { GetGameBookingHeatmapDto } from "../../../models/analytics/dto/get-game-booking-heatmap.dto";
import { shiftMatrix } from "../../../utils/matrix";
import { AnalyticsFilterParams, buildFilterSuffix } from "./analyticsFilterParams";

export const GET_GAME_BOOKING_HEATMAP_QUERY_KEY = 'gameBookingHeatmap';

export const useGetGameBookingHeatmap = (locationId: string, startDate: Date, endDate: Date, filters?: AnalyticsFilterParams) => {
    const apiClient = useApiClient();
    return useQuery({
        queryKey: [GET_GAME_BOOKING_HEATMAP_QUERY_KEY, locationId, startDate.toISOString(), endDate.toISOString(), filters?.courtIds, filters?.sportTypes],
        queryFn: async () => {
            const heatmapData = await apiClient.fetchApi<GetGameBookingHeatmapDto, {}>({
                method: 'GET',
                endpoint: `analytics/game-booking-heatmap?locationId=${locationId}&startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}${buildFilterSuffix(filters)}`
            });

            const offsetInHours = -Math.floor(new Date().getTimezoneOffset() / 60);
            const shiftedHeatmap = shiftMatrix(heatmapData.value, offsetInHours);
            return { value: shiftedHeatmap };
        },
        // No `placeholderData`. It used to hand back a 7x24 matrix of zeros,
        // which React Query counts as data: `isLoading` was pinned to false so
        // the card's spinner never rendered, and a FAILED read painted a full
        // week of "zero bookings in every hour" — an analytics answer the
        // operator had no way to tell apart from a real quiet week.
        enabled: !!locationId,
        staleTime: 5 * 60 * 1000,
    });
}
